"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.header = exports.footer = exports.content = exports.headerIcons = exports.base = void 0;

var _util = require("../../../util");

const base = ({
  cssProps,
  theme
}) => {
  const {
    transitionState = 'mounted',
    fullScreen = false,
    isSidebar = false
  } = cssProps;
  const isMounted = transitionState === 'mounted';
  return {
    zIndex: 1,
    // default for overlay is 1, it should be the same to be in front of
    background: (0, _util.color)(theme, theme.modals.background),
    borderRadius: isSidebar ? 0 : (0, _util.spacing)(theme, theme.modals.borderRadius),
    boxShadow: (0, _util.boxShadow)(theme, theme.modals.boxShadow),
    margin: 'auto',
    maxHeight: '100%',
    width: fullScreen ? theme.modals.fullScreenWidth : theme.modals.width,
    opacity: isMounted ? 1 : 0,
    overflow: 'hidden',
    position: 'relative',
    transform: isMounted || isSidebar ? 'none' : 'translateY(10%) scale3D(0.9, 0.9, 1)',
    transition: 'all 0.2s ease',
    ...(isSidebar && {
      height: '100%'
    })
  };
};

exports.base = base;

const headerIcons = () => ({
  minWidth: 32
});

exports.headerIcons = headerIcons;

const content = ({
  theme,
  cssProps
}) => {
  const {
    isSidebar
  } = cssProps;
  return {
    backgroundAttachment: 'local, scroll',
    backgroundImage: "linear-gradient(0deg, ".concat((0, _util.color)(theme, theme.modals.background), " 0px 2px, transparent 2px), linear-gradient(0deg, transparent 0px 0.5px, ").concat((0, _util.color)(theme, theme.modals.borderColor), " 0.5px 1.5px, transparent 1.5px)"),
    maxHeight: isSidebar ? '100%' : theme.modals.maxHeightContent,
    overflowY: 'auto',
    padding: (0, _util.spacing)(theme, theme.modals.padding)
  };
};

exports.content = content;

const footer = ({
  theme
}) => ({
  padding: (0, _util.spacing)(theme, theme.modals.paddingFooter)
});

exports.footer = footer;

const header = ({
  theme
}) => ({
  boxShadow: (0, _util.boxShadow)(theme, theme.modals.boxShadowHeader),
  height: 72,
  padding: (0, _util.spacing)(theme, theme.modals.paddingHeader)
});

exports.header = header;
//# sourceMappingURL=Modal.style.js.map